import { render } from "./LinkVariant.vue?vue&type=template&id=41a81a42"
import script from "./LinkVariant.vue?vue&type=script&lang=js"
export * from "./LinkVariant.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/LinkVariant.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "41a81a42"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('41a81a42', __exports__)) {
    api.reload('41a81a42', __exports__)
  }
  
  module.hot.accept("./LinkVariant.vue?vue&type=template&id=41a81a42", () => {
    api.rerender('41a81a42', render)
  })

}


export default __exports__